import React from "react";
import Reveal from "@/components/Reveal";
import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";

const LEGAL_LINKS = [
  { slug: "termeni-si-conditii", label: "Termeni și Condiții" },
  { slug: "confidentialitate", label: "Confidențialitate (GDPR)" },
  { slug: "cookies", label: "Cookie-uri" },
  { slug: "retur", label: "Retur & Retragere" },
  { slug: "livrare", label: "Livrare & Plată" },
  { slug: "anpc", label: "ANPC / SAL" },
];

export default function Footer() {
  return (
    <footer id="contact" className="border-t border-black/10 pt-24 pb-12" data-testid="footer">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <Reveal>
          <div className="grid md:grid-cols-12 gap-12 pb-20">
            <div className="md:col-span-6">
              <h3 className="font-serif font-light text-4xl md:text-6xl leading-none tracking-tight max-w-xl">
                Intră în <span className="italic text-gramur">ritualul</span> rufelor curate.
              </h3>
              <div className="mt-10 flex flex-col sm:flex-row gap-3 max-w-md">
                <input
                  data-testid="newsletter-email"
                  type="email"
                  placeholder="Adresa ta de email"
                  className="flex-1 bg-transparent border-b border-black/15 focus:border-gramur outline-none py-3 text-sm transition-colors"
                />
                <button
                  data-testid="newsletter-submit"
                  className="px-7 py-3 bg-[#0E0F12] text-[#EDEAE3] text-xs tracking-widest uppercase rounded-sm hover:-translate-y-[2px] transition-transform duration-300"
                >
                  Abonează-te
                </button>
              </div>
            </div>

            <div className="md:col-span-3 md:col-start-8">
              <p className="text-[11px] tracking-[0.3em] uppercase text-[#4A4844] mb-5">Colecție</p>
              <ul className="space-y-3 text-sm text-[#4A4844]">
                <li className="hover:text-[#0E0F12] transition-colors cursor-pointer">Lavandă</li>
                <li className="hover:text-[#0E0F12] transition-colors cursor-pointer">Gramur</li>
                <li className="hover:text-[#0E0F12] transition-colors cursor-pointer">Ocean</li>
                <li className="hover:text-[#0E0F12] transition-colors cursor-pointer">Degresanți</li>
              </ul>
            </div>

            <div className="md:col-span-2">
              <p className="text-[11px] tracking-[0.3em] uppercase text-[#4A4844] mb-5">Contact</p>
              <ul className="space-y-3 text-sm text-[#4A4844]">
                <li><a href="mailto:contact@deter-ecobox.ro" className="hover:text-[#0E0F12] transition-colors">contact@deter-ecobox.ro</a></li>
                <li><a href="tel:+40785454967" className="hover:text-[#0E0F12] transition-colors">+40 (785) 454 967</a></li>
                <li>București, RO</li>
              </ul>
            </div>
          </div>
        </Reveal>

        {/* Informații legale */}
        <div className="grid md:grid-cols-12 gap-8 py-10 border-t border-black/10">
          <div className="md:col-span-6">
            <p className="text-[11px] tracking-[0.3em] uppercase text-[#4A4844] mb-4">Informații legale</p>
            <div className="text-sm text-[#4A4844] space-y-1 leading-relaxed" data-testid="footer-company-info">
              <p className="text-[#0E0F12] font-medium">AXD - EVERY TRANS S.R.L.</p>
              <p>Reg. com.: J2022001044526</p>
              <p>CIF: RO46998538</p>
              <p>Str. Decebal, camera 1, bl. 59/2D, sc. B, et. 4, ap. 35, Mun. Giurgiu, jud. Giurgiu</p>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] tracking-[0.3em] uppercase text-[#4A4844] mb-4">Documente</p>
            <ul className="space-y-2 text-sm text-[#4A4844]">
              {LEGAL_LINKS.map((l) => (
                <li key={l.slug}>
                  <Link to={`/legal/${l.slug}`} data-testid={`footer-legal-${l.slug}`} className="hover:text-[#0E0F12] transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] tracking-[0.3em] uppercase text-[#4A4844] mb-4">Protecția consumatorului</p>
            <a
              href="https://reclamatiisal.anpc.ro"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="anpc-sal-banner"
              aria-label="ANPC — Soluționarea Alternativă a Litigiilor"
              className="inline-flex items-center gap-2.5 h-[50px] w-[250px] max-w-full rounded-[3px] bg-[#0B3D6B] text-white px-3.5 hover:opacity-90 transition-opacity"
            >
              <span className="text-[10px] font-bold tracking-wider leading-none border border-white/50 rounded px-2 py-1.5">ANPC</span>
              <span className="text-[10px] leading-snug">Soluționarea Alternativă<br />a Litigiilor (SAL)</span>
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-6 pt-10 border-t border-black/10">
          <p className="font-serif text-lg">
            deter<span className="text-gramur">-ecobox</span>.ro
          </p>
          <div className="flex items-center gap-5 text-[#4A4844]">
            <Instagram className="w-5 h-5 hover:text-[#0E0F12] transition-colors cursor-pointer" strokeWidth={1.2} />
            <Facebook className="w-5 h-5 hover:text-[#0E0F12] transition-colors cursor-pointer" strokeWidth={1.2} />
          </div>
          <p className="text-xs text-[#4A4844]">© {new Date().getFullYear()} · AXD - EVERY TRANS S.R.L.</p>
        </div>
      </div>
    </footer>
  );
}
